import { Pipe, PipeTransform } from '@angular/core';

import { KPI } from '../../@core/api';
import { QuantityUnitsService } from '../../@core/utils';

@Pipe({
    name: 'ngxAssetQuantity',
    pure: false,
    standalone: true,
})
export class AssetQuantityPipe implements PipeTransform {
  private cachedResult: string = '';
  private cachedAssetId: number;

  constructor(
    private quantityUnitsService: QuantityUnitsService,
  ) { }

  transform(asset: KPI.MappedAsset): string {
    if (asset) {
      if (this.cachedAssetId !== asset.id) {
        this.cachedResult = '';
        this.cachedAssetId = asset.id;
        this.quantityUnitsService.quantityUnits$.subscribe((quantityUnits) => {
          const assetUnit = quantityUnits.find(
            (quantityUnit) => quantityUnit.id === asset.asset_type_object.quantity_unit,
          );

          this.cachedResult = `${assetUnit ? `${assetUnit.name}` : 'u'}`;
        });
      }

      return this.cachedResult;
    }
  }
}
